export default __webpack_public_path__ + "static/infinity-rewards-front-42e9aef5487d63e26bc4f020d15328de.png";